angular.module('leanlaw').controller('ContingencyReportCtrl', ['$scope', '$rootScope', '$filter', '$timeout', '$state', "alerts", 'userService', 'reportsService', 'accountingService', "exportJson", "singleRequest", "objectNumberManipulator", "messageBus", function ($scope, $rootScope, $filter, $timeout, $state, alerts, userService, reportsService, accountingService, exportJson, singleRequest, objectNumberManipulator, messageBus) {
  $scope.vm = {
    me: {
      terms: {
        Matter: ""
      }
    },
    data: {
      clients: [],
      filteredClients: [],
      data: {}
    },
    filter: {},
    loading: true,
    printing: false,
    search: "",
    format: {},
    sort: ['client.label', 'matter.label'],
    reverse: false,
    trust: false,
    accounting: false
  };
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matterHeader = $scope.vm.me.terms.Matter;
    const exp = $scope.vm.data.filteredClients.reduce((accum, c) => {
      var client = {
        "Client": c.client.label || c.client.name,
        [matterHeader]: "",
        "Fee": "",
        "Hours": $filter("hoursDecimal")(c.data.hours.nonBillable),
        "Hours Amount": $filter("amount")(c.data.hours.nonBillableCost),
        "Fixed fees": $filter("amount")(c.data.amounts.charges),
        "Expenses": $filter("amount")(c.data.amounts.expenses),
        "Total amount": $filter("amount")(c.data.amounts.total)
      };
      if ($scope.vm.accounting === true) client.Collected = $filter("amount")(c.data.collected.total);
      if ($scope.vm.trust === true) client.Trust = $filter("amount")(c.data.accounting.trust);
      accum.push(client);
      c.matters.forEach(m => {
        var matter = {
          "Client": "",
          [matterHeader]: m.matter.label || m.matter.name,
          "Fee": $filter("percentage")(m.matter.contingencyFeePercentage ?? ''),
          "Hours": $filter("hoursDecimal")(m.data.hours.nonBillable),
          "Hours Amount": $filter("amount")(m.data.hours.nonBillableCost),
          "Expenses": $filter("amount")(m.data.amounts.expenses),
          "Total amount": $filter("amount")(m.data.amounts.total)
        };
        if ($scope.vm.accounting === true) matter.Collected = $filter("amount")(m.data.collected.total);
        if ($scope.vm.trust === true) matter.Trust = $filter("amount")(m.data.accounting.trust);
        accum.push(matter);
      });
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  userService.me().then(me => {
    $scope.vm.me = me;
    accountingService.verify(false).then(status => {
      $scope.vm.accounting = status.connected;
    }).catch(() => {
      $scope.vm.accounting = false;
    });
    $scope.vm.trust = me.company.settings.trustEnabled;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.vm.filter = Object.assign($scope.vm.filter, payload);
      // Necessary to set this value for the requests

      $scope.vm.filter.status = $scope.vm.filter.archived.status;
      $scope.vm.filter.billedFilter = $scope.vm.filter.contingencyBilledFilter;
      $scope.vm.filter.scope = $scope.vm.filter.filter.scope;
      filterClientEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.vm.filter = Object.assign($scope.vm.filter, payload);
    });
    $scope.$on("report-clientmatter-change", (event, cm) => {
      singleRequest.cancel("contingency");
      $scope.goToSummary(cm.client ? cm.client.id : null, cm.matter ? cm.matter.id : null);
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
    messageBus.addMessage("clientmatter-set", true, {});
  });
  function filterClientEntries() {
    $scope.vm.loading = true;
    var query = angular.copy($scope.vm.filter);
    query.data = "services,expenses,charges,hours,cost,payments";
    if ($scope.vm.trust) {
      query.data += ',trust';
    }
    query.billingType = "contingency";
    singleRequest.serviceCall("contingency", reportsService.getClientReport)(query).then(data => {
      if (!data) return;
      data.clients.forEach(c => {
        c.data.amounts.total += c.data.hours.nonBillableCost;
        c.matters.forEach(m => {
          m.data.amounts.total += m.data.hours.nonBillableCost;
        });
      });
      data.data.amounts.total += data.data.hours.nonBillableCost;
      $scope.vm.data = data;
      $scope.vm.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.vm.loading = false;
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("contingency");
    deactivate();
  });

  // MatterId may be optional
  $scope.goToSummary = function (clientId, matterId) {
    $state.go("reports.contingency-detail", {
      clientId,
      matterId,
      return: "reports.contingency",
      report: `Contingency ${$scope.vm.me.terms.Matter}s`
    });
  };

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.vm || !$scope.vm.data) return;
    $scope.vm.data.filteredClients = $filter('orderBy')($filter('filter')($scope.vm.data.clients, $scope.vm.search), $scope.vm.sort, $scope.vm.reverse) || [];
    $scope.vm.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.vm.sort, $scope.vm.reverse) || [];
    });
  }

  // Totals follow the searched set, as they did when this recomputed from the
  // DOM-populated array. Deliberately not on the data/sort watches, so a reload
  // keeps the figures the API returned.
  function updateTotals() {
    if (!$scope.vm.data || !$scope.vm.data.filteredClients) return;
    objectNumberManipulator.resetValues($scope.vm.data.data);
    ($scope.vm.data.filteredClients || []).forEach(row => {
      objectNumberManipulator.sumValues($scope.vm.data.data, row.data);
    });
  }
  $scope.$watch('vm.data.clients', updateFiltered);
  $scope.$watch('vm.search', () => {
    updateFiltered();
    updateTotals();
  });
  $scope.$watchGroup(['vm.sort', 'vm.reverse'], updateFiltered);
}]);